"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_LIMITS_TABLE_COPY = void 0;
exports.ENTITY_LIMITS_TABLE_COPY = {
    ITEM: 'Item',
    LIMIT: 'Limit',
    PERCENT_USED: '% Used',
    USAGE: 'Usage'
};
//# sourceMappingURL=ENTITY_LIMITS_TABLE_COPY.js.map